import { TbMailPlus } from 'react-icons/tb'
import { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Form, FormField } from '@/Core/UI/Form'
import { createFormContext } from '@/Core/UI/Form/Providers/FormContextProvider'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { FormRow, FormSection } from '@/Ship/Components/Form/FormSection'
import { FormDrawer } from '@/Ship/Components/UI/AppDrawer/FormDrawer'
import { UserResource } from '../../Resources/UserResource'
import { UserNameFields } from '../UserNameFields'
import { InvitationUserStore } from '../../Stores/InvitationUserStore'

interface Props {
    crudContext: any
    title?: string
    open: boolean
    onClose: () => void
}

/** Секції й ряди — як у картці співробітника (UserEditTemplate) */
const UsersForm = ({ formContext }: any) => (
    <Form formContext={formContext}>
        <FormSection title="Контакти" hint="Посилання для входу прийде листом на цей E-Mail і діятиме 6 годин">
            <UserNameFields formContext={formContext} />
            <FormRow>
                <FormField name="phone" />
                <FormField name="email" />
            </FormRow>
        </FormSection>
        <FormSection title="Доступ">
            <FormRow>
                <FormField name="roles" />
                <FormField name="position" />
            </FormRow>
        </FormSection>
    </Form>
)

export const InvitationUserDrawer = observer(
    ({ crudContext, title = 'Запросити співробітника', open, onClose }: Props) => {
        const [store] = useState(() => new InvitationUserStore())
        const { showSuccess, showError } = useNotification()

        const { roles, email, phone, position } = UserResource.fields || {}

        const formContext = useMemo(
            () =>
                createFormContext({
                    fields: {
                        lastName: UserResource.fields?.['lastName'],
                        firstName: UserResource.fields?.['firstName'],
                        middleName: UserResource.fields?.['middleName'],
                        phone: { ...phone, isRequired: true },
                        email: { ...email, isRequired: true },
                        roles: { ...roles, isRequired: true, isMultiple: false },
                        position,
                    },
                    onSubmit: async ({ values, formContext }: any) => {
                        const ok = await store.submit(values, formContext, { success: showSuccess, error: showError })
                        if (ok) {
                            setTimeout(() => crudContext.listContext?.actions?.load?.(true), 200)
                            onClose()
                        }
                    },
                }),
            // eslint-disable-next-line react-hooks/exhaustive-deps
            []
        )

        // The form context lives as long as the drawer component, so values, errors
        // and the "Запрошено" button state from the previous invitation survive a
        // close. Clear them on every open so the form always starts blank (BUG-8).
        useEffect(() => {
            if (open) {
                formContext.reset()
                store.resetSuccess()
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [open])

        const handleClose = () => {
            store.resetSuccess()
            onClose()
        }

        return (
            <FormDrawer
                title={title}
                open={open}
                onClose={handleClose}
                formContext={formContext}
                submitLabel="Запросити"
                submitIcon={<TbMailPlus />}
                submitting={store.loading}
                submitted={store.successSubmit}
                submittedLabel="Запрошено"
            >
                <UsersForm formContext={formContext} />
            </FormDrawer>
        )
    }
)
